export enum FormFields {
  Email = 'email',
  Password = 'password',
  NewPassword = 'new_password',
  ConfirmNewPassword = 'confirm_new_password'
}

export interface FormValues {
  email: string;
  password: string;
  new_password: string;
  confirm_new_password: string;
}

export interface CreateSessionFormConfig {
  id: FormFields;
  placeholder: string;
  isLabelAnimated?: boolean;
  isShowSearch?: boolean;
  isValueHidden?: boolean;
  cypress: string;
}
